export default __webpack_public_path__ + "static/media/slack-toolbox.bfb0157d.svg";